import { Injectable } from '@angular/core';
import { AppConfig, UvExplorerClient } from 'common';
import { Observable, Subject } from 'rxjs/Rx';
import { GetApiKeysResultDto, ApiKeyDto, ApiKeyTransferResultDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { UpdateResultDto } from 'UvExplorerServer.Dtos.TS';
import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { List } from "DiscoveryEngine.TS/Utils";


@Injectable()
export class ApiKeysWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		return;
	}

	public getApiKeys(): Observable<List<ApiKeyDto>> {
		let url = this.appConfig.authServiceUrl + `api/auth/apikeys`;
		let subject = new Subject<List<ApiKeyDto>>();

		this.uvExplorerClient.getObjSer<GetApiKeysResultDto>(url, GetApiKeysResultDto).subscribe(
			(result: GetApiKeysResultDto) => {
				subject.next(result.ApiKeys);
			},
			(error) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public createApiKey(apiKey: ApiKeyDto): Observable<ApiKeyDto> {

		let body = {
			create_api_key_request: {}
		};

		apiKey.Write(body.create_api_key_request, {});

		let url = this.appConfig.authServiceUrl + `api/auth/apikeys`;
		let subject = new Subject<ApiKeyDto>();

		this.uvExplorerClient.postObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				apiKey.CopyProps(result, true);
				subject.next(apiKey);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public updateApiKey(apiKey: ApiKeyDto): Observable<ApiKeyDto> {
		let body = {
			update_api_key_request: {}
		};

		apiKey.Write(body.update_api_key_request, {});

		let url = this.appConfig.authServiceUrl + `api/auth/apikeys`;
		let subject = new Subject<ApiKeyDto>();

		this.uvExplorerClient.putObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				apiKey.CopyProps(result, false);
				subject.next(apiKey);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public deleteApiKey(apiKeyGuid: string): Observable<boolean> {
		let body = {
			delete_api_key_request: {
				api_key_guid: apiKeyGuid
			}
		};

		let url = this.appConfig.authServiceUrl + `api/auth/apikeys`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

	public doApiKeyTransfer(apiKeyGuid: string, oldUserGuid: string, newUserGuid: string): 
							Observable<ApiKeyTransferResultDto> {
		let body = {
			api_key_transfer_request: {
				user_guid: oldUserGuid,
				api_key_guid: apiKeyGuid,
				target_user_guid: newUserGuid,
			}
		};

		let url = this.appConfig.authServiceUrl + `api/auth/apikeys/transfer`;
		return this.uvExplorerClient.postObjSer(url, body, ApiKeyTransferResultDto);
	}

}
